module.exports = __webpack_public_path__ + "img/blaabaertaerte.c01ad874.jpg";